import React, { useEffect, useState } from 'react';
import { WindowUtils, Account } from 'msal';
import { Loader } from 'components/Loader';
import { setAccessToken } from 'redux/actions';
import { getMe } from 'redux/thunks';
import { authAgent, loginUserWithRedirect, getAccessTokenSilent, getAccessTokenPopup, getAccessTokenInteractive } from 'auth/authUtils';
import { RootStore } from 'redux/store';
import { useDispatch, useSelector } from 'react-redux';

/* 
    Derived from
    https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/samples/msal-core-samples/react-sample-app/src/AuthProvider.js
    
    More useful reading on MSAL can be found here
    https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-core/docs/FAQ.md
*/

const withAuth = (PassedComponent: React.ComponentType) => {
	const WithAuth: React.FC = props => {
		const dispatch = useDispatch();
		const meLoading = useSelector((state: RootStore) => state.user.meLoading);
		const userId = useSelector((state: RootStore) => state.user.userId);
		const accessToken = useSelector((state: RootStore) => state.auth.accessToken);
		const [error] = useState('');
		const [account, setAccount] = useState<Account>();
		const { ...cleanedProps } = props;

		useEffect(() => {
			const getToken = async () => {
				const accessTokenResult = await acquireToken();
				if (accessTokenResult) {
					dispatch(setAccessToken(accessTokenResult.accessToken, accessTokenResult.expiresOn));
				}
			};

			const msalAccount = authAgent.getAccount();
			setAccount(msalAccount);

			if (accessToken) {
				dispatch(getMe());
			}

			if (!WindowUtils.isInIframe()) {
				if (msalAccount && !accessToken) {
					getToken();
				} else if (!msalAccount) {
					onSignIn(true);
				}
			}
		}, [accessToken, dispatch]);

		const acquireToken = async () => {
			return await getAccessTokenSilent(authAgent)
				.then(success => {
					return success;
				})
				.catch(error => {
					console.warn('Error occurred acquiring token silently');
					return getAccessTokenInteractive(authAgent)
						.then(success => {
							return success;
						})
						.catch(error => {
							console.warn('Error occurred acquiring token with redirect');
							return getAccessTokenPopup(authAgent)
								.then(success => {
									return success;
								})
								.catch(error => {
									console.warn('Error occurred acquiring token with popup');
									return error;
								});
						});
				});
		};

		const onSignIn = async (redirect: boolean) => {
			if (redirect) {
				return await loginUserWithRedirect(authAgent);
			}
		};


		if (WindowUtils.isInIframe()) {
			return <></>;
		} else if (account && accessToken && !meLoading && userId !== '') {
			return <PassedComponent {...cleanedProps} />;
		} else if (error) {
			return <div>{error}</div>;
		} else {
			return (
				<div style={{ height: '100vh' }}>
					<Loader height='full' />
				</div>
			);
		}
	};

	return WithAuth;
};

export default withAuth;
